import { ElementRef, Injectable } from '@angular/core';
import { SharedService } from './shareModule/services/shared.service';
import { AuthServiceService } from './shareModule/services/auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class AdServiceService {

  constructor(private sharedService: SharedService, private auth: AuthServiceService) {} 

  public disposeAds(): void {
    if (this.sharedService.isBrowser()) {
      if (this.rightAdChangeTimeout) {
        clearTimeout(this.rightAdChangeTimeout);
        this.rightAdChangeTimeout = null;
      }
      if (this.leftAdChangeTimeout) {
        clearTimeout(this.leftAdChangeTimeout);
        this.leftAdChangeTimeout = null;
      }
    }
  }
  public showAdLeft = true;
  public showAdRight = true;

  public leftAds = [];
  public rightAds = [];
  public currentLeftAd = null;
  public currentRightAd = null;

  public rightAdChangeTimeout = null;
  public leftAdChangeTimeout = null;

  private getRandom(max) {
    let rnd = Math.random() * max;
    rnd = Math.floor(rnd);
    return rnd;
  }



  private wait(time): Promise<void> {
    return new Promise((res) => {
      setTimeout(res, time);
    });
  }

  private leftAd? : ElementRef | null;
  private rightAd? : ElementRef | null;
  

  private startLeftSideChange() {
    if (this.leftAds.length > 1) {
      if (this.leftAdChangeTimeout) {
        clearTimeout(this.leftAdChangeTimeout);
      }
      this.leftAdChangeTimeout = setTimeout(async () => {
        if (this.currentLeftAd && this.showAdLeft) {
          this.leftAd.nativeElement.style.opacity = 0;
          await this.wait(20_000);
          this.leftAd.nativeElement.style.opacity = 1;
        }
        this.currentLeftAd =
          this.leftAds[this.getRandom(this.leftAds.length - 1)];
        this.startLeftSideChange();
      }, this.currentLeftAd.disappearTime * 1000);
    }
  }
  private startRightSideChange() {
    console.log('Next righ ad set');
    if (this.rightAds.length > 1) {
      if (this.rightAdChangeTimeout) {
        clearTimeout(this.rightAdChangeTimeout);
      }
      this.rightAdChangeTimeout = setTimeout(async () => {
        if (this.currentRightAd && this.showAdRight) {
          this.rightAd.nativeElement.style.opacity = 0;
          await this.wait(20_000);
          this.rightAd.nativeElement.style.opacity = 1;
        }
        //console.log(this.rightAds)
        this.currentRightAd =
          this.rightAds[this.getRandom(this.rightAds.length)];
        this.startRightSideChange();
      }, this.currentRightAd.disappearTime * 1000);
    }
  }
  private correctLink(link: string) {
    if (link.startsWith('https') || link.startsWith('http')) {
      return link;
    } else if (link.startsWith('www')) {
      return 'http://' + link;
    }
    return `http://www.${link}`;
  }
  public openCorrectedLink(link) {
    if (!link || typeof link != 'string') {
      console.warn('empty link given!');
      return;
    }
    window.open(this.correctLink(link), '_blank');
  }

  public getSiteAds(
    leftSideAdElementRef: ElementRef,
    rightSideAdElementRef: ElementRef
  ) {
    this.leftAd = leftSideAdElementRef;
    this.rightAd = rightSideAdElementRef
    //the ads at the top
    if (this.sharedService.isBrowser()) {
      setTimeout(() => {
        this.auth.getAllHomepageAds().subscribe({
          next: (data: any) => {
            const ads = data.data;

            this.leftAds = ads.filter((ad) => ad.isOnLeft);
            this.rightAds = ads.filter((ad) => !ad.isOnLeft);

            this.currentLeftAd = this.leftAds.find((ad) => ad.isFirstAd);
            if (!this.currentLeftAd && this.leftAds.length) {
              this.currentLeftAd = this.leftAds[0];
            }

            this.currentRightAd = this.rightAds.find((ad) => ad.isFirstAd);
            if (!this.currentRightAd && this.rightAds.length) {
              this.currentRightAd = this.rightAds[0];
            }

            this.startRightSideChange();
            this.startLeftSideChange();
          },
          error: console.error,
        });
      }, 10_000);
    }
  }

  public tempCloseAdLeft() {
    this.showAdLeft = false;
    setTimeout(() => {
      this.showAdLeft = true;
    }, 10 * 60_000);
  }
  public tempCloseAdRight() {
    this.showAdRight = false;
    setTimeout(() => {
      this.showAdRight = true;
    }, 10 * 60_000);
  }
  
}
